import React from "react";
import { Container, Row, Col } from "reactstrap";

const BenefitCard = (props) => {
  return (
    <React.Fragment>
      <div className="mt-4">
        <div className="d-flex align-items-start">
          <div className="flex-shrink-0">
            <i className={`${props.icon} text-primary fs-4 me-3`}></i>
          </div>
          <div className="flex-grow-1">
            <h6 className="fw-bold mb-1">{props.title}</h6>
            <p className="text-muted mb-0 fs-14">{props.description}</p>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const BenefitsData = [
  {
    icon: "mdi mdi-shield-check",
    title: "Garantia de 25 Anos",
    description: "Painéis com garantia de performance de longo prazo",
  },
  {
    icon: "mdi mdi-cash-multiple",
    title: "Retorno em 3-5 Anos",
    description: "Investimento que se paga rapidamente",
  },
  {
    icon: "mdi mdi-leaf",
    title: "100% Sustentável",
    description: "Energia limpa e renovável para o planeta",
  },
  {
    icon: "mdi mdi-home-city",
    title: "Valorização do Imóvel",
    description: "Aumente o valor do seu patrimônio em até 8%",
  },
];

const About = () => {
  return (
    <React.Fragment>
      <section className="section bg-light" id="quem-somos">
        <Container>
          <Row className="align-items-center g-3 g-lg-5">
            <Col lg={6}>
              <div className="about-box bg-white p-4 p-lg-5 rounded box-shadow">
                <p className="text-uppercase text-primary mb-1 fw-bold">Quem Somos</p>
                <h3 className="mb-3">
                  Transformando o sol em economia e sustentabilidade
                </h3>
                <p className="text-muted">
                  A <strong>Araucária Solar</strong> nasceu com a missão de democratizar o acesso
                  à energia solar no Brasil. Com equipe altamente qualificada e comprometida,
                  já realizamos mais de 500 projetos de instalação fotovoltaica para residências,
                  comércios e indústrias.
                </p>
                <p className="text-muted">
                  Nossa experiência de mais de <strong>6 anos no mercado</strong> nos permite
                  oferecer soluções personalizadas, desde o dimensionamento até a homologação
                  junto à concessionária de energia.
                </p>

                <div className="benefits mt-4">
                  {BenefitsData.map((value, idx) => (
                    <BenefitCard
                      key={idx}
                      icon={value.icon}
                      title={value.title}
                      description={value.description}
                    />
                  ))}
                </div>
              </div>
            </Col>
            <Col lg={6}>
              <div className="about-stats">
                <Row className="g-4">
                  <Col xs={6}>
                    <div className="stat-box bg-white p-4 rounded box-shadow text-center">
                      <h2 className="text-primary mb-1 fw-bold">2018</h2>
                      <p className="text-muted mb-0 fs-14">Ano de Fundação</p>
                    </div>
                  </Col>
                  <Col xs={6}>
                    <div className="stat-box bg-white p-4 rounded box-shadow text-center">
                      <h2 className="text-primary mb-1 fw-bold">+500</h2>
                      <p className="text-muted mb-0 fs-14">Clientes Satisfeitos</p>
                    </div>
                  </Col>
                  <Col xs={6}>
                    <div className="stat-box bg-white p-4 rounded box-shadow text-center">
                      <h2 className="text-primary mb-1 fw-bold">2MW+</h2>
                      <p className="text-muted mb-0 fs-14">Potência Instalada</p>
                    </div>
                  </Col>
                  <Col xs={6}>
                    <div className="stat-box bg-white p-4 rounded box-shadow text-center">
                      <h2 className="text-primary mb-1 fw-bold">95%</h2>
                      <p className="text-muted mb-0 fs-14">Economia na Conta</p>
                    </div>
                  </Col>
                </Row>
                <div className="mt-4 p-4 bg-primary rounded text-white text-center">
                  <h5 className="mb-2">Pronto para economizar?</h5>
                  <p className="mb-3 opacity-75">
                    Faça uma simulação gratuita e descubra quanto você pode economizar
                  </p>
                  <a href="#contato" className="btn btn-light">
                    Solicitar Orçamento Grátis
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default About;
